/**
 * Date range options for booking exports.
 * Determines the time period of bookings to include in the export.
 */
export default Object.freeze({
  /**
   * Export bookings from the last 7 days.
   */
  Last7Days: 'last7',

  /**
   * Export bookings from the last 30 days.
   */
  Last30Days: 'last30',

  /**
   * Export bookings from a user-specified custom date range.
   * Requires the user to select start and end dates via the date picker.
   */
  Custom: 'custom',
})
